/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import {
  updateOverviewIssue,
  fetchAllIssues,
} from "../../services/apiService/issueApi";
import { fetchUserForForm } from "../../services/apiService/userApi";
import IssueDetails from "../../components/forms/NewIssueForm";
import { FaArrowDown, FaArrowUp } from "react-icons/fa";
import { FaSearch, FaTimes } from "react-icons/fa";
import { CustomTable } from "../../components/Table";
import Pencils from "../../assets/pencil.png";
import * as XLSX from "xlsx";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
} from "../../components/ui/Popover";
import Book from "../../assets/book.png";
import SortDropdown from "../../components/ui/DropdownSort";
import DropdownCheckbox from "../../components/ui/DropdownCheck";
import useToaster from "../../hooks/useToaster";
import { PageSkeletons, Spinner } from "../../components/ui/Skeleton";
import { MdOutlineFilterAlt } from "react-icons/md";
import FilterChips from "../../components/ui/FilterChip";
import Pagination from "../../components/ui/Pagination";
import DynamicFilterPopover from "../../components/ui/DynamicFilterPopover";
import { fetchVolIss } from "../../services/apiService/articleApi";
import DataSyncError from "../../components/edgeCases/DataSyncError";

const IssueOverviewTable = ({ setIsReload }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [lastSync, setLastSync] = useState(new Date());
  const [selectedVolIss, setSelectedVolIss] = useState(["All"]);
  const [showVolIssOptions, setShowVolIssOptions] = useState(false);
  const [showSortOptions, setShowSortOptions] = useState(false);
  const [tempSortDirection, setTempSortDirection] =
    useState("Sort by Ascending");
  const [allIssues, setAllIssues] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [selectedIssue, setSelectedIssue] = useState(null);
  const [error, setError] = useState(null);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [isFocused, setIsFocused] = useState(false);
  const [isAdditionalFilterOpen, setIsAdditionalFilterOpen] = useState(false);
  const dropdownRef = useRef(null);
  const scrollContainerRef = useRef(null);
  const [hasLoadedOnce, setHasLoadedOnce] = useState(false);
  const [loadingState, setLoadingState] = useState("spinning");
  const [selectedFieldConfig, setSelectedFieldConfiguration] = useState([]);

  const [activeRowId, setActiveRowId] = useState(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const [task, setTask] = useState([]);
  const [tempTask, setTempTask] = useState([]);

  const { userData, preferences, dataSyncTime } = useSelector(
    (state) => state.user
  );
  const isEditable = userData?.issueOverview?.toLowerCase() === "edit";
  const [sortConfig, setSortConfig] = useState({
    key: null,
    direction: "asc",
  });
  const [tempSortKey, setTempSortKey] = useState(null);

  const userId = userData?.id;
  const showToast = useToaster();

  const [hasFilters, setHasFilters] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [UserOption, setUserOption] = useState([]);
  const [userOptionsMap, setUserOptionsMap] = useState([]);
  let [volIssOptions, setVolIssOptions] = useState([]);

  const searchTriggeredRef = useRef(false);
  const FirstTriggeredRef = useRef(false);

  let [journalPopover, setJournalPopover] = useState(false);
  let [teamPopover, setTeamPopover] = useState(false);

  let [JournalOptions, setJournalOptions] = useState([]);
  let [teamOptions, setTeamOptions] = useState([
    { label: "All", value: "Alll" },
    { label: "Silver", value: "Silver" },
    { label: "Blue", value: "Blue" },
  ]);

  let [selectedJournals, setSelectedJournals] = useState(["All"]);
  let [selectedJournalIds, setSelectedJournalIds] = useState([]);
  let [tempSelectedJournals, setTempSelectedJournals] = useState(["All"]);
  let [selectedTeam, setSelectedTeam] = useState(["All"]);
  let [tempIssueS300Date, setTempIssueS300Date] = useState(false);
  let [issueS300Date, setIssueS300Date] = useState(false);


  const isSearchEmpty = useMemo(() => {
    return searchTerm.trim().length < 1;
  }, [searchTerm]);

  const headers = {
    Issue: [
      { key: "journalName", value: "JOURNAL" },
      { key: "volIss", value: "VOL/ISS" },
      { key: "issueS300Date", value: "ISSUE S300 DATE" },
      {
        key: "CoverHandlerUserFullName",
        value: "COVER HANDLER",
      },
      {
        key: "TocHandlerUserFullName",
        value: "TOC HANDLER",
      },
      {
        key: "FinalizingHandlerUserFullName",
        value: "FINALIZING HANDLER",
      },
      {
        key: "WebHandlerUserFullName",
        value: "WEB HANDLER",
      },
      { key: "team", value: "TEAM" },
    ],
  };

  let fetchUserData = async () => {
    try {
      let response = await fetchUserForForm();
      if (response?.success) {
        const { userNames, userOptions } = response?.data;
        setUserOption(userNames);
        setUserOptionsMap(userOptions);
      }
    } catch (err) {
      console.log(err);
    }
  };
const handleTempIssueS300Date = (val) => {
  setTempIssueS300Date(tempIssueS300Date === val ? "" : val);
}
  const fetchIssuesData = async () => {
    try {
      setIsLoading(true);
      const response = await fetchAllIssues({
        page: currentPage,
        limit: itemsPerPage,
        volIss: selectedVolIss,
        task: task,
        issueS300Date: issueS300Date,
        id: userId,
        search: searchTerm.trim(),
        key: sortConfig.key,
        direction: sortConfig.direction,
        journal: selectedJournalIds.map((j) => j.value),
        team: selectedTeam,
      });

      if (response?.data?.data.length >= 1) {
        const fetchedIssues = response.data.data;

        setAllIssues(fetchedIssues);
        setTotalItems(response.data.pagination?.totalItems);
        setTotalPages(response.data.pagination?.totalPages);
      } else {
        setAllIssues([]);
        setTotalItems(0);
        setTotalPages(1);
      }
    } catch (err) {
      console.error("Error fetching issues:", err.message, err.response?.data);
      setAllIssues([]);
      setTotalItems(0);
      setTotalPages(1);
    } finally {
      setIsLoading(false);
    }
  };

  const handleInitialLoading = async () => {
    const startTime = Date.now();

    if (!hasLoadedOnce) {
      setLoadingState("spinning");
    }

    try {
      await fetchIssuesData();
      FirstTriggeredRef.current = true;
    } catch (err) {
      console.error("Error in fetchAllIssues:", err);
    } finally {
      if (!hasLoadedOnce) {
        const timeTaken = Date.now() - startTime;

        if (timeTaken < 2000) {
          setLoadingState("data");
          setHasLoadedOnce(true);
        } else if (timeTaken < 5000) {
          setTimeout(() => {
            setLoadingState("data");
            setHasLoadedOnce(true);
          }, 2000);
        } else {
          setTimeout(() => {
            setLoadingState("skeleton");
            setTimeout(() => {
              setLoadingState("data");
              setHasLoadedOnce(true);
            }, 2000);
          }, 3000);
        }
      }
    }
  };

  useEffect(() => {
    handleInitialLoading();
  }, []);

  useEffect(() => {
    if (!FirstTriggeredRef.current) return;
    fetchIssuesData();
  }, [
    itemsPerPage,
    currentPage,
    task,
    issueS300Date,
    selectedVolIss,
    sortConfig,
    preferences,
    selectedJournalIds,
    selectedTeam,
  ]);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!searchTriggeredRef.current) return;
      if (searchTerm.trim().length > 2 || !searchTerm.trim()) {
        fetchIssuesData();
      }
    }, 600);

    return () => clearTimeout(timeoutId);
  }, [searchTerm]);

  let fetchVolIssOptions = async () => {
    try {
      let response = await fetchVolIss({
        id: "",
        type: "Issue",
        time: "",
        journal: "",
        place: "issueOverview",
      });
      setVolIssOptions(response?.data?.data?.volIss);
      setJournalOptions(response?.data?.data?.journalId);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchVolIssOptions();
  }, []);

  useEffect(() => {
    const scrollContainer = scrollContainerRef.current;
    const handleScroll = () => {
      if (activeRowId !== null) {
        setActiveRowId(null);
      }
    };
    if (scrollContainer) {
      scrollContainer.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (scrollContainer) {
        scrollContainer.removeEventListener("scroll", handleScroll);
      }
    };
  }, [activeRowId]);

  const handleDownload = (rowData) => {
    try {
      if (!rowData) {
        throw new Error("No data available to download for this row");
      }

      const excelHeaders = headers.Issue.map((h) => h.value);
      const data = [
        headers.Issue.reduce((acc, header) => {
          acc[header.value] = rowData[header.key];
          return acc;
        }, {}),
      ];

      const worksheet = XLSX.utils.json_to_sheet(data, {
        header: excelHeaders,
      });
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Issue Overview");

      const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
      const fileName = `IssueOverviewRow_${
        rowData.volIss || "Unknown"
      }_${timestamp}.xlsx`;

      XLSX.writeFile(workbook, fileName);
    } catch (err) {
      console.error("Download Error:", err);
      setError(`Download failed: ${err.message}`);
    }
    setIsPopoverOpen(false);
  };

  const HandleDownload = (e, row) => {
    e.preventDefault();
    e.stopPropagation();
    handleDownload(row);
    setActiveRowId(null);
  };

  const actions = (row, rowIndex) => (
    <div
      className="flex items-center justify-center space-x-4 relative"
      ref={dropdownRef}
    >
      {isEditable && (
        <div
          onClick={() => {
            handleEditClick(row);
          }}
          className="p-2 rounded-md hover:bg-[#B8C7FE] cursor-pointer"
        >
          <img
            src={Pencils}
            alt="Edit"
            className="max-w-[16px] min-w-[8px] max-h-[16px] min-h-[8px] "
          />
        </div>
      )}
      <Popover
        open={activeRowId === row.id + rowIndex}
        onOpenChange={(open) => setActiveRowId(open ? `${row.id}` : null)}
      >
        <PopoverTrigger>
          <div className="px-3 py-1 rounded-md hover:bg-[#B8C7FE] cursor-pointer">
            <i className="fas fa-ellipsis-v h-3 w-1"></i>
          </div>
        </PopoverTrigger>
        <PopoverContent
          className="bg-white p-0 w-[165px] h-[46px] shadow-lg rounded-md border border-gray-200"
          align="end"
          sideOffset={5}
        >
          <button
            className="px-3 py-2 mt-1 text-[13px] text-[#35424D] hover:bg-[#EDF0FC] w-full text-left"
            onClick={(e) => HandleDownload(e, row)}
          >
            Download Article Report
          </button>
        </PopoverContent>
      </Popover>
    </div>
  );

  const handleEditClick = async (row) => {
    setSelectedFieldConfiguration(
      row.ArticleDetails?.[0]?.journalInfo?.fieldConfiguration || []
    );
    setSelectedIssue(row);
    await fetchUserData();
  };

  const handleCloseForm = () => {
    setSelectedIssue(null);
    setActiveRowId(null);
  };

  const handleUpdateIssue = async (updatedIssue) => {
    if (!isEditable) {
      setError("You do not have permission to edit issues.");
      return;
    }

    try {
      const response = await updateOverviewIssue(updatedIssue.id, updatedIssue);
      if (response.success) {
        showToast("Task updated successfully");
        fetchIssuesData();
        setSelectedIssue(null);
        setActiveRowId(null);
      } else {
        showToast(response.message || "Failed to update issue");
      }
    } catch (error) {
      showToast("Failed to update issue. Please try again.");
    }
  };

  const handleVolIssSelection = (selected) => {
    const newSelection =
      selected.includes("All") || selected.length === 0 ? ["All"] : selected;
    setSelectedTeam(newSelection);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (newSize) => {
    setItemsPerPage(newSize);
    setCurrentPage(1);
  };

  useEffect(() => {
   if (task.length > 0 || issueS300Date === true) {
    setHasFilters(true);
  } else {
    setHasFilters(false);
  }
  }, [task,issueS300Date]);

  const handleTempTaskChange = (task) => {
    setTempTask(
      task
      //     (prev) =>
      //   prev.includes(task) ? prev.filter((t) => t !== task) : [...prev, task]
    );
  };

  const IssueSection = [
    {
      label: "Task",
      key: "task",
      values: [
        { value: "coverHandler", label: "Cover handling" },
        { value: "tocHandler", label: "TOC handling" },
        { value: "webHandler", label: "Web handling" },
        { value: "finalizingHandler", label: "Finalizing handling" },
      ],
    },
    {
      label: "Include published Issue",
      key: "issueS300Date",
      values: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
    },
  ];

  const IssueTempValues = {
    task: tempTask,
    issueS300Date: tempIssueS300Date,
  
  };

  const IssueSetTempValues = {
    task: handleTempTaskChange,
    issueS300Date: handleTempIssueS300Date,
  };

  const applyFilters = () => {
    setTask(tempTask);
    setIsAdditionalFilterOpen(false);
    //setHasFilters(true);
    setCurrentPage(1);
    setIssueS300Date(tempIssueS300Date);
  };

  const handleJournalSelection = (selected, journals) => {
    let journalOption = JournalOptions;
    const validJournals = Array.isArray(journals) ? journals : [];
    const newSelection =
      selected.includes("All") ||
      selected.length === 0 ||
      journalOption.length === selected.length
        ? ["All"]
        : selected;

    const isAllSelected =
      (Array.isArray(newSelection) &&
        newSelection.length === 1 &&
        newSelection[0] === "All") ||
      journalOption.length === selected.length;
    setSelectedJournals(newSelection);

    setTempSelectedJournals(
      isAllSelected ? newSelection : validJournals.map((data) => data.value)
    );
    setSelectedJournalIds(validJournals);
  };

  const getFilterLabel = (selectedItems, defaultLabel, options = []) => {
    if (selectedItems?.includes("All") || selectedItems?.length === 0) {
      return `${defaultLabel}: All`;
    }
    const selectedLabels = selectedItems?.map((item) => {
      const option = options?.find((opt) => opt?.value === item);
      return option?.label ?? item;
    });
    return selectedLabels?.length === 1
      ? `${defaultLabel}: ${selectedLabels?.[0]}`
      : `${defaultLabel}: ${selectedLabels?.[0]} + more`;
  };

  useEffect(() => {
    if (isAdditionalFilterOpen) {
      setTempTask(task);
      setTempIssueS300Date(issueS300Date);
    }
  }, [isAdditionalFilterOpen, task,issueS300Date]);

  if (error) {
    return (
      <div className="p-4 text-red-500 text-center font-sans">{error}</div>
    );
  }

  const filters = {
    searchTerm: searchTerm.trim() || null,
    selectedVolIss: selectedVolIss.includes("All") ? null : selectedVolIss,
    task: task.length > 0 ? task : null,
    Journal: selectedJournals.includes("All") ? null : selectedJournals,
    Team: selectedTeam.includes("All") ? null : selectedTeam,
   issueS300Date:
    issueS300Date === true
      ? "Yes"      
      : null,
 };

  const handleRemoveFilter = (filterKey, value) => {
    console.log("Removing filter:", filterKey, value);
    switch (filterKey) {
      case "searchTerm":
        setSearchTerm("");
        break;
      case "selectedVolIss":
        handleVolIssSelection(selectedVolIss.filter((v) => v !== value));
        break;
      case "task":
        setTask(task.filter((t) => t !== value));
        break;
      case "issueS300Date":
        console.log(value);
       if (value === "Yes") { 
        setIssueS300Date(false);
        setTempIssueS300Date(false);
      }
      break;
      case "Journal":
        handleJournalSelection(
          selectedJournals.filter((j) => j !== value),
          selectedJournalIds.filter((j) => j.label !== value)
        );
        break;
      case "Team":
        const updated = selectedTeam.filter((j) => j !== value);
        setSelectedTeam(updated.length ? updated : ["All"]);
        break;
      default:
        break;
    }
    setCurrentPage(1);
  };

  const handleClearAllFilters = () => {
    setSearchTerm("");
    setSelectedVolIss(["All"]);
    setTask([]);
    setSelectedJournals(["All"]);
    setIssueS300Date(false);
    setTempIssueS300Date(false); 
    setTempSelectedJournals(["All"]);
    setSelectedJournalIds([]);
    setSelectedTeam(["All"]);
    setHasFilters(false);
    setCurrentPage(1);
  };

  let handleAdvancedClear = () => {
    setTempTask([]);
    setTempIssueS300Date(false);   
  };

  return (
    <div
      className="bg-gray-100 flex flex-col"
      style={{
        fontFamily: "Source Sans Pro, sans-serif",
        height: "calc(100vh - 72px)",
      }}
    >
      <div className="flex-1 p-6 bg-white flex flex-col h-full">
        {loadingState === "spinning" ? (
          <div className="flex items-center justify-center h-full">
            <Spinner />
          </div>
        ) : loadingState === "skeleton" ? (
          <PageSkeletons />
        ) : (
          <>
            {selectedIssue ? (
              <div className="overflow-y-auto flex-1 h-full">
                <IssueDetails
                  text="Issue Overview"
                  formdata={selectedIssue}
                  fieldConfig={selectedFieldConfig}
                  onSave={handleUpdateIssue}
                  Onclose={handleCloseForm}
                  userOption={UserOption}
                  optionsMap={userOptionsMap}
                />
              </div>
            ) : (
              <div className="flex flex-col h-full">
                {/* Filter/Search Section - Fixed at top */}
                <div className="header-section bg-white sticky top-0 z-[50]">
                  <div className="flex justify-between items-center mb-2">
                    <h1 className="text-[#20282E] text-[23px] h-[32px] font-semibold">
                      Issue Overview {totalItems > 0 && `(${totalItems})`}
                    </h1>
                    <div className="text-[#35424D] text-[11px] flex items-center">
                      <DataSyncError />
                      Last Sync: {dataSyncTime?.value}
                      <br></br>
                      {/* {dataSyncTime?.value
                        ? "Snowflake data not available."
                        : ""} */}
                    </div>
                  </div>
                  <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-3 w-full">
                    <div className="relative w-[246px]">
                      <input
                        type="text"
                        placeholder="Search"
                        maxLength={100}
                        className={`border rounded-[4px] w-[246px] h-[32px] py-[4px] px-[12px] pr-[32px] text-sm transition-colors ${
                          isFocused
                            ? " focus:border-[#35424D] focus:border focus:outline-none"
                            : "border-gray-300"
                        }`}
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          searchTriggeredRef.current = true;
                        }}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                      />
                      {searchTerm ? (
                        <FaTimes
                          className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer text-[#C3C3C3] hover:text-gray-700"
                          onClick={() => {
                            setSearchTerm("");
                            setIsLoading(true);
                          }}
                        />
                      ) : (
                        <FaSearch className="absolute right-3 top-1/2 transform -translate-y-1/2 text-[#C3C3C3]" />
                      )}
                    </div>
                    <div className="flex flex-wrap items-center space-x-4 mt-1 sm:mt-0">
                      <Popover
                        open={showSortOptions}
                        onOpenChange={setShowSortOptions}
                      >
                        <PopoverTrigger asChild>
                          <button
                            className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1] ${
                              showSortOptions ? "bg-[#D9D9D9]" : ""
                            }`}
                          >
                            <span className="text-[#35424D] font-semibold text-[13px] flex items-center gap-1">
                              Sort by :
                              <span className="flex items-center font-medium gap-1">
                                {sortConfig.direction === "asc" ? (
                                  <FaArrowUp className="text-[#35424D] h-[12px]" />
                                ) : sortConfig.direction === "desc" ? (
                                  <FaArrowDown className="text-[#35424D] h-[12px]" />
                                ) : null}
                                {sortConfig.key && headers.Issue
                                  ? headers.Issue.find(
                                      (h) => h.key === sortConfig.key
                                    )?.value || headers.Issue[0].value
                                  : ""}
                              </span>
                            </span>
                            <i
                              className={`fas fa-chevron-down text-xs ${
                                showSortOptions ? "transform rotate-180" : ""
                              }`}
                            />
                          </button>
                        </PopoverTrigger>
                        <SortDropdown
                          headers={headers.Issue}
                          activeTab="Issue"
                          isOpen={showSortOptions}
                          sortConfig={sortConfig}
                          setSortConfig={setSortConfig}
                          tempSortKey={tempSortKey}
                          setTempSortKey={setTempSortKey}
                          tempSortDirection={tempSortDirection}
                          setTempSortDirection={setTempSortDirection}
                          setShowSortOptions={setShowSortOptions}
                          setClientPagination={() => setCurrentPage(1)}
                        />
                      </Popover>

                      <Popover
                        open={journalPopover}
                        onOpenChange={(open) => {
                          if (!open) {
                            setJournalOptions((prev) => [...prev]);
                          }
                          setJournalPopover(open);
                        }}
                      >
                        <PopoverTrigger asChild>
                          <button
                            className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1]   ${
                              journalPopover ? "bg-[#D9D9D9]" : ""
                            }`}
                            onClick={() => {
                              setJournalPopover(!journalPopover);
                            }}
                          >
                            <span className="text-[#35424D] text-[13px]">
                              <span className="font-semibold">Journal</span>{" "}
                              <span className="font-medium">
                                {getFilterLabel(
                                  selectedJournals,
                                  "",
                                  JournalOptions
                                ).replace(/^Journal:\s*/, "")}
                              </span>
                            </span>
                            <i
                              className={`fas fa-chevron-down text-xs ${
                                journalPopover ? "rotate-180" : ""
                              }`}
                            />
                          </button>
                        </PopoverTrigger>
                        <DropdownCheckbox
                          options={JournalOptions}
                          selectedValues={tempSelectedJournals}
                          onSelectionChange={handleJournalSelection}
                          selectAllText="All"
                          clearAllText="Clear all"
                          applyText="Apply"
                          type="Journal"
                          isOpen={journalPopover}
                          label={true}
                          searchPlaceholder="Search journals..."
                          onClose={() => setJournalPopover(false)}
                          SetSelectedValuesId={(ids) => {
                            setTempSelectedJournals(
                              ids.length >= 1 &&
                                JournalOptions.length !== ids.length
                                ? ids?.map((id) => id?.value)
                                : ["All"]
                            );

                            setSelectedJournalIds(
                              ids.length >= 1 &&
                                JournalOptions.length !== ids.length
                                ? ids
                                : []
                            );
                          }}
                        />
                      </Popover>

                      <Popover
                        open={teamPopover}
                        onOpenChange={(open) => {
                          if (!open) {
                            setTeamOptions((prev) => [...prev]);
                          }
                          setTeamPopover(open);
                        }}
                      >
                        <PopoverTrigger asChild>
                          <button
                            className={`flex items-center gap-1 px-3 py-1 h-[32px] rounded-md hover:bg-[#EFF1F1]   ${
                              teamPopover ? "bg-[#D9D9D9]" : ""
                            }`}
                            onClick={() => {
                              setTeamPopover(!teamPopover);
                            }}
                          >
                            <span className="text-[#35424D] text-[13px]">
                              <span className="font-semibold">Team</span>{" "}
                              <span className="font-medium">
                                {/* {selectedTeam[0] === "All"
                                  ? "All"
                                  : selectedTeam[0]} */}
                                {getFilterLabel(
                                  selectedTeam,
                                  "",
                                  teamOptions
                                ).replace(/^Team:\s*/, "")}
                              </span>
                            </span>
                            <i
                              className={`fas fa-chevron-down text-xs ${
                                teamPopover ? "transform rotate-180" : ""
                              }`}
                            />
                          </button>
                        </PopoverTrigger>
                        <DropdownCheckbox
                          options={teamOptions}
                          selectedValues={selectedTeam}
                          onSelectionChange={handleVolIssSelection}
                          isOpen={teamPopover}
                          selectAllText="All"
                          clearAllText="Clear all"
                          applyText="Apply"
                          searchPlaceholder="Search Team..."
                          onClose={() => setTeamPopover(false)}
                        />
                      </Popover>

                      <Popover
                        open={isAdditionalFilterOpen}
                        onOpenChange={setIsAdditionalFilterOpen}
                      >
                        <PopoverTrigger asChild>
                          <button className="flex items-center justify-center w-[32px] h-[32px] rounded-md hover:bg-[#B8C7FF]  ">
                            <div className="relative">
                              <MdOutlineFilterAlt className="text-[#1C40C9] w-[15px] h-[15px]" />
                              {hasFilters && (
                                <span className="absolute top-[-2px] right-[-2px] w-[6px] h-[6px] bg-red-500 rounded-full"></span>
                              )}
                            </div>
                          </button>
                        </PopoverTrigger>
                        <DynamicFilterPopover
                          sections={IssueSection}
                          tempSelected={IssueTempValues}
                          setTempSelected={IssueSetTempValues}
                          clearAllFilters={handleAdvancedClear}
                          applyFilters={applyFilters}
                          type="Issue"
                        />
                      </Popover>
                    </div>
                  </div>
                  {searchTerm.length >= 3 && (
                    <p className="mt-1 mb-4 text-sm text-gray-600">
                      Showing search results:{" "}
                      <span className="text-black italic">'{searchTerm}'</span>
                    </p>
                  )}
                  {(searchTerm.trim() ||
                    selectedVolIss[0] !== "All" ||
                    selectedJournals[0] !== "All" ||
                    selectedTeam[0] !== "All" ||
                    task.length > 0 || issueS300Date === true) && (
                    <FilterChips
                      filters={filters}
                      onRemoveFilter={handleRemoveFilter}
                      onClearAll={handleClearAllFilters}
                    />
                  )}
                </div>

                {/* Table Section - Scrollable middle area */}
                <div
                  ref={scrollContainerRef}
                  className={`content-section overflow-y-auto ${
                    allIssues.length > 0
                      ? "border border-[#DCDCDC] rounded-md"
                      : ""
                  }`}
                >
                  {isLoading && allIssues.length === 0 ? (
                    <div className="flex flex-col items-center justify-center h-[50vh]">
                      <Spinner />
                    </div>
                  ) : allIssues.length === 0 && !filters.searchTerm ? (
                    <div className="flex flex-col items-center justify-center mt-[10%]">
                      <img
                        src={Book}
                        alt="No issues"
                        style={{
                          width: "90px",
                          height: "90px",
                        }}
                      />
                      <p
                        className="text-[#35424D] font-semibold text-[27px] mt-10"
                        style={{ fontFamily: "Source Sans Pro, sans-serif" }}
                      >
                        No issue information at the moment
                      </p>
                    </div>
                  ) : (
                    <div className="h-full">
                      <CustomTable
                        data={allIssues}
                        actions={actions}
                        searchTerm={searchTerm.trim()}
                        setSearchTerm={setSearchTerm}
                        setLoading={setIsLoading}
                        headers={headers.Issue}
                        activeTab="Issue"
                        sortConfig={sortConfig}
                        setSortConfig={setSortConfig}
                        setActiveRowId={setActiveRowId}
                        activeRowId={activeRowId}
                      />
                    </div>
                  )}
                </div>

                {allIssues.length > 0 && (
                  <div className="sticky mt-auto bottom-0 bg-white">
                    <Pagination
                      currentPage={currentPage}
                      totalPages={totalPages}
                      totalItems={totalItems}
                      itemsPerPage={itemsPerPage}
                      onPageChange={handlePageChange}
                      onItemsPerPageChange={handleItemsPerPageChange}
                    />
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default IssueOverviewTable;
